/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./describeServer.defs.js";
export { main as default } from "./describeServer.defs.js";
